import React from "react";
import styles from "./Privacy.module.css";
import { getContactData } from "../utils/extractConfigData";

const Cookies = () => {
  const contactData = getContactData();

  return (
    <section className={styles.privacySection}>
      <div className={styles.container}>
        <h1>Cookiebeleid</h1>
        
        <div className={styles.content}>
          <h2>1. Wat zijn cookies?</h2>
          <p>
            Cookies zijn kleine tekstbestanden die op uw computer of mobiele apparaat worden opgeslagen 
            wanneer u een website bezoekt. Ze worden veel gebruikt om websites efficiënter te laten 
            werken, evenals om informatie te verstrekken aan de eigenaren van de website.
          </p>

          <h2>2. Welke cookies gebruiken wij?</h2>
          <p>
            Onze website <strong>maakt geen gebruik van tracking-, analytics- of marketingcookies</strong>. 
            We verzamelen en analyseren geen persoonlijke gegevens over uw surfgedrag.
          </p>
          
          <p>
            Op onze website worden alleen de volgende soorten cookies gebruikt:
          </p>
          
          <h3>Strikt noodzakelijke cookies</h3>
          <p>
            Dit zijn cookies die essentieel zijn voor het functioneren van de website. Zonder deze 
            cookies zouden bepaalde functionaliteiten, zoals het onthouden van uw taalkeuze of het in een 
            winkelmandje bewaren van de door u geselecteerde items, niet werken. Deze cookies verzamelen 
            geen informatie over u die gebruikt kan worden voor marketingdoeleinden.
          </p>
          
          <h3>Functionele cookies</h3>
          <p>
            Deze cookies laten de website toe bepaalde keuzes die u gemaakt heeft te onthouden, zoals uw 
            taalvoorkeur of de regio waar u zich bevindt, om zo de website beter en persoonlijker te maken. 
            De informatie die door deze cookies wordt verzameld, kan geen personen identificeren en volgt 
            uw surfactiviteit op andere websites niet.
          </p>

          <h2>3. Hoe lang worden cookies bewaard?</h2>
          <p>
            De cookies die wij gebruiken worden opgeslagen tot ze vervallen, of tot u ze verwijdert via 
            uw browserinstellingen.
          </p>

          <h2>4. Hoe kunt u cookies beheren?</h2>
          <p>
            U kunt uw browserinstellingen wijzigen om cookies te beheren. U kunt cookies verwijderen die 
            al op uw computer zijn opgeslagen en u kunt uw browser instellen om te voorkomen dat cookies 
            worden geplaatst. Als u dit doet, moet u mogelijk sommige voorkeuren elke keer dat u onze 
            website bezoekt handmatig instellen en sommige diensten werken mogelijk niet.
          </p>
          
          <p>
            Meer informatie over cookies en hoe u ze kunt beheren vindt u op 
            <a href="https://www.allaboutcookies.org/" target="_blank" rel="noopener noreferrer"> www.allaboutcookies.org</a>.
          </p>

          <h2>5. Updates van dit cookiebeleid</h2>
          <p>
            Dit cookiebeleid kan worden bijgewerkt om wijzigingen in onze website of veranderende 
            regelgeving weer te geven. We raden u aan regelmatig deze pagina te bezoeken om op de hoogte 
            te blijven van eventuele wijzigingen.
          </p>

          <h2>6. Contact</h2>
          <p>
            Heeft u vragen over ons cookiebeleid? Neem dan contact met ons op via:
          </p>
          <p className={styles.contact}>
            E-mail: {contactData.email}
          </p>
          
          <p>
            Laatste update: {new Date().toLocaleDateString('nl-BE')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Cookies; 